import dayjs from '../../services/wrappers/dayjs';

/**
 * Return the end of today
 * @returns {Date}
 */
export default function endOfToday() {
    return dayjs().endOf('day').toDate();
}
